import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

export const RESET_STORE = "app/resetStore";

const appReducer = combineReducers({
  login: require("./login/loginSlice").default,
  appointment: require("./appointment/appointmentSlice").default
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer
});

export const resetStore = () => ({ type: RESET_STORE });

export default store;
